<template>
    <div class="cache-widget" v-animate-css="{ classes: 'slideInUp', delay: 0, duration: 300 }">
        <div class="widget-header">
            <div class="header-left">
                <i class="material-icons">storage</i>
                <div class="header-text">
                    <strong>{{ $t("cache.management") }}</strong>
                    <small>{{ story.title }}</small>
                </div>
            </div>
            <md-button class="md-icon-button" @click="$emit('close-menu', 0)">
                <md-icon>close</md-icon>
            </md-button>
        </div>

        <div class="widget-body">
            <CacheManager
                :default-filters="{ actorType: 'chatbot', actorId: storyId }"
                :modal-mode="true"
            />
        </div>
    </div>
</template>

<script>
import CacheManager from "../../../../../Cache/CacheManager.vue";
import { mapState } from "vuex";

export default {
    name: "CacheWidget",
    components: {
        CacheManager,
    },
    props: {
        storyId: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapState({
            story() {
                return this.$store.state.CB.current || { title: "Chatbot" };
            },
        }),
    },
};
</script>

<style lang="scss" scoped>
.cache-widget {
    background: white;
    border-radius: 15px;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    height: calc(100vh - 150px);
    max-height: 100%;
    max-width: 100%;
    overflow: hidden;
    width: 900px;
    z-index: 999;

    .widget-header {
        align-items: center;
        background: white;
        border-bottom: 1px solid #e8e8e8;
        border-radius: 15px 15px 0 0;
        display: flex;
        justify-content: space-between;
        padding: 20px 24px;

        .header-left {
            display: flex;
            align-items: center;
            gap: 12px;

            .material-icons {
                font-size: 30px;
                color: #1890ff;
            }

            .header-text {
                display: flex;
                flex-direction: column;
                gap: 4px;

                strong {
                    font-size: 18px;
                    letter-spacing: 0.5px;
                }

                small {
                    color: #666;
                    font-size: 13px;
                }
            }
        }
    }

    .widget-body {
        flex-grow: 1;
        overflow-y: auto;
        background: #fafafa;
    }
}
</style>

